import { connect } from 'react-redux';

import ChunkBookmark from './ChunkBookmark';
import * as bookmarkSelectors from 'edrolo/domains/bookmarks/selectors';

function makeMapStateToProps() {
  return (state, ownProps) => {
    const getChunkBookmark = bookmarkSelectors.makeGetChunkBookmark();
    return {
      bookmark: getChunkBookmark(state, ownProps),
    };
  };
}

export default connect(makeMapStateToProps)(ChunkBookmark);
